import { addDays, isFuture } from "date-fns";
import stringify from "fast-json-stable-stringify";
import { GetCoastPreviousNextFeedQueryVariables, PublishRecordFragment } from "@ihr-radioedit/inferno-webapi";

export enum COAST_SHOW_TYPE {
    SOMEWHERE_IN_TIME = "SOMEWHERE_IN_TIME",
    ART_BELL_VAULT = "ART_BELL_VAULT",
    UPCOMING = "UPCOMING",
    CLASSIC = "CLASSIC",
    REGULAR = "REGULAR",
}

export const getCoastShowType = (show: PublishRecordFragment): COAST_SHOW_TYPE => {
    const showCollectionToType = {
        "collections/Coast to Coast AM Art Bell Vault": COAST_SHOW_TYPE.ART_BELL_VAULT,
        "collections/Coast to Coast AM Classic Show": COAST_SHOW_TYPE.CLASSIC,
        "collections/Coast to Coast AM Somewhere In Time": COAST_SHOW_TYPE.SOMEWHERE_IN_TIME,
    };

    if (isFuture(show.pub_start)) {
        return COAST_SHOW_TYPE.UPCOMING;
    }

    for (const tagSet of show.subscription) {
        for (const tag of tagSet.tags) {
            if (tag in showCollectionToType) {
                return showCollectionToType[tag];
            }
        }
    }

    return COAST_SHOW_TYPE.REGULAR;
};

export const getPreviousNextFetchParams = (content: PublishRecordFragment) => {
    const queryVariables: GetCoastPreviousNextFeedQueryVariables = {
        type: content.type,
        query: {
            pub_start: addDays(content.pub_start, 5).getTime(),
            pub_until: new Date().getTime(),
            subscription: [
                {
                    tags: content.subscription.flatMap(sub => sub.tags.filter(tags => tags.startsWith("collections/"))),
                },
            ],
            limit: 20,
        },
    };

    const cacheKey = stringify(queryVariables);

    return { queryVariables, cacheKey };
};

export const previousNextViewNameToTitle = (viewName: string) => {
    switch (viewName) {
        case "shows_detail":
        case "somewhere_in_time_detail":
        case "upcoming_shows_detail":
        case "classic_shows_detail":
            return "Shows";
        case "articles_detail":
            return "Articles";
        case "guests_detail":
            return "Guests";
        case "photos_detail":
            return "Photos";
        default:
            return "";
    }
};
